var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.13128 7.13128C7.47299 6.78957 8.02701 6.78957 8.36872 7.13128L11.9929 10.7555L15.6164 7.13197C15.9581 6.79026 16.5122 6.79026 16.8539 7.13197C17.1956 7.47368 17.1956 8.0277 16.8539 8.36941L13.2304 11.9929L16.8539 15.6164C17.1956 15.9581 17.1956 16.5122 16.8539 16.8539C16.5122 17.1956 15.9581 17.1956 15.6164 16.8539L11.9929 13.2304L8.36872 16.8546C8.02701 17.1963 7.47299 17.1963 7.13128 16.8546C6.78957 16.5129 6.78957 15.9588 7.13128 15.6171L10.7555 11.9929L7.13128 8.36872C6.78957 8.02701 6.78957 7.47299 7.13128 7.13128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleX);
export default __webpack_public_path__ + "static/media/circleX.8b7fcfbe2ffd86eb59bee26b20b4cac6.svg";
export { ForwardRef as ReactComponent };